module.exports = __webpack_public_path__ + "static/img/icon-in-progress.7d4f8742.svg";